import React from 'react'
import { connect } from 'redaction'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './BeautyBagSteps.scss'


const BeautyBagSteps = ({ className, stepsLeft = 3 }) => {
  let titleMessage = {
    ...messages.bestOffer,
    values: {
      count: stepsLeft,
    },
  }

  let descMessage = messages.addToUnlock

  if (stepsLeft === 1) {
    titleMessage = messages.almostThere
  }

  if (stepsLeft === 0) {
    titleMessage = messages.yay
    descMessage = messages.unlocked
  }

  const firstStepClassName = cx(s.step, {
    [s.inactiveFlag]: stepsLeft === 3,
    [s.bird]: stepsLeft === 2,
    [s.activeFlag]: stepsLeft < 2,
  })

  const secondStepClassName = cx(s.step, {
    [s.inactiveFlag]: stepsLeft > 1,
    [s.bird]: stepsLeft === 1,
    [s.activeFlag]: stepsLeft === 0,
  })

  const thirdStepClassName = cx(s.step, {
    [s.inactiveBag]: stepsLeft !== 0,
    [s.activeBag]: stepsLeft === 0,
  })

  const firstArrowClassName = cx(s.arrow, {
    [s.active]: stepsLeft < 2,
  })

  const secondArrowClassName = cx(s.arrow, {
    [s.active]: stepsLeft === 0,
  })

  return (
    <div className={className}>
      <Text
        message={titleMessage}
        html
        align="center"
        size="14-24"
        uppercase
      />
      <div className={s.steps}>
        <div className={firstStepClassName} />
        <div className={firstArrowClassName} />
        <div className={secondStepClassName} />
        <div className={secondArrowClassName} />
        <div className={thirdStepClassName} />
      </div>
      <Box mt="16">
        <Text
          message={descMessage}
          align="center"
          values={{ count: stepsLeft }}
          size="14-24"
          html
        />
      </Box>
    </div>
  )
}


export default connect({
  stepsLeft: 'models.cart.items.beautyBag.stepsLeft',
})(BeautyBagSteps)
